import { css as t } from "@microsoft/fast-element";
import { normalize as r } from "../common/normalize.js";
import { display as c } from "@matrix42/fast-foundation";
import { designTokens as o } from "../design-tokens.js";
const a = t`
  ${r}
  ${c("inline-flex")}
  :host {
    /* Base */
    outline: none;
  }

  :host(:focus-visible) .switch {
    /* Style */
    outline: ${o.borderWidth.sm} solid ${o.color.black};
    outline-offset: ${o.borderWidth.sm};
  }

  :host(.checked) .switch {
    /* Style */
    background-color: ${o.color.primary[100]};
  }

  :host(:hover) .switch {
    /* Style */
    background-color: ${o.color.neutral[80]};
  }

  :host(.checked:hover) .switch {
    /* Style */
    background-color: ${o.color.primary[200]};
  }

  :host(.checked) .indicator {
    /* Base */
    left: calc(1.125 * ${o.spacing[4]});
  }

  :host(:active) .switch {
    /* Style */
    background-color: ${o.color.neutral[500]};
  }

  :host(.checked:active) .switch {
    /* Style */
    background-color: ${o.color.primary[500]};
  }

  :host(:disabled) .switch {
    /* Style */
    background-color: ${o.color.neutral[70]} !important;
  }

  :host(:disabled) .indicator {
    /* Style */
    background-color: ${o.color.neutral[60]} !important;
  }

  .switch {
    /* Base */
    position: relative;
    /* Layout */
    width: calc(2.313 * ${o.spacing[4]});
    height: ${o.spacing[5]};
    /* Style */
    border-radius: ${o.spacing["2.5"]};
    background-color: ${o.color.neutral[70]};
  }

  .indicator {
    /* Base */
    position: absolute;
    left: ${o.spacing["0.5"]};
    top: ${o.spacing["0.5"]};
    /* Layout */
    width: calc(1.063 * ${o.spacing[4]});
    height: ${o.spacing[4]};
    /* Style */
    border-radius: 50%;
    background-color: ${o.color.white};
    /* Transition */
    transition: left ${o.transition.fast};
  }
`;
export {
  a as switchStyles
};
